<template>
  <basic-container>
    <div class="relending-detail-container">
      <div class="inner-con">
        <!-- 2022/09/02 新增流水号跳转 -->
        <div class="project-title">{{basicInfoData.name?basicInfoData.name:''}} 
          <span v-if="basicInfoData.flowableId" class="title-number" @click="goBatch(basicInfoData.flowableId)">（流水号：{{basicInfoData.number?basicInfoData.number:''}}）</span> 
        </div>
        <div class="project-status">
          <div class="status-title">审批状态</div>
          <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
              {{basicInfoData.auditStatusStr}}
          </div>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="详情信息" name="first">
            <InfoContainer
                style="margin-top:20px;"
                :infoTitle="projectConfig['infoTitle']"
                :contentConfig="projectConfig['infoContent']"
            >
              <template #basicInfo>
                <CommonDetail
                    :configArray="detailFormConfig"
                    :initValue="basicInfoData"
                >
                </CommonDetail>
              </template>
            </InfoContainer>


            <!-- 流程公共附件 -->
            <Accessory
                v-loading="!dataReady"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(153, 153, 153, 0.8)"
                v-if="uploadPermissionNameOne!='' && uploadPermissionNameTwo!='' && basicInfoData.auditStatus == 0 || (basicInfoData.auditStatus != 0 && basicInfoData.flowableId != '')"
                :idname="uploadPermissionNameTwo"
                :fileMenuUrlname="uploadPermissionNameOne"
                :projectid="id"
                :upload="true"
                :batchFileUpload="true"
                :permissionList="permissionList"
                :isPermission="true"
            />
            
            <!-- 流程设计审批信息表单 -->
            <AuditInfo
                ref="auditInfo"
                v-loading="!dataReady"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(153, 153, 153, 0.8)"
                v-if="(isStartedProcess && auditFormData && auditFormData != {}) && (basicInfoData.flowableId != '' && basicInfoData.auditStatus != 0)"
                :formDetailData="auditFormData"
                :isEditable="processDetail.process?processDetail.process.isEditable:false"
                :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            />

            

            <!-- 会签意见区 -->
            <CommentStep
                v-loading="!dataReady"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(153, 153, 153, 0.8)"
                v-if="commentList.length > 0"
                :commentList="commentList"
                :taskSaveData="taskSaveData"
                :taskNo="processDetail.process?Number(processDetail.process.taskNo): 0"
                :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            />
            <!-- 流程记录  -->
            <CommentTable
                v-loading="!dataReady"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(153, 153, 153, 0.8)"
                v-if="flowData.length>0"
                :flowData="flowData"
            />

            <!-- 会签意见区 -->
            <InfoContainer
                v-if="!isStartedProcess && (basicInfoData.auditStatus == 0 || (basicInfoData.auditStatus != 0 && basicInfoData.flowableId != ''))"
                class="comment-container"
                style="margin-top:20px;"
                :infoTitle="commentBlockConfig['infoTitle']"
                :contentConfig="commentBlockConfig['infoContent']"
            >
                <template #comment>
                    <CommentBlock
                        ref="commentBlock"
                        @fileChange="fileChange"
                        :id='id'
                    />
                </template>
            </InfoContainer>
          </el-tab-pane>

          <!-- 合同列表 -->
          <el-tab-pane label="合同列表" name="third" v-if="basicInfoData.auditStatus == 2">
            <template v-if="activeName == 'third'">
              <InfoContainer
                  style="margin-top:20px;"
                  :infoTitle="contractConfig['infoTitle']"
                  :contentConfig="contractConfig['infoContent']"
              >
                <template #contractList>
                  <avue-crud
                      :option="contractOption"
                      :data="contractListData"
                      ref="crud"
                      :page.sync="page"
                      :search.sync="queryContractList"
                      v-model="form"
                      :before-open="beforeOpenScope"
                      @on-load="queryContractList"
                  >
                    <template slot="projectName" slot-scope="{ row }">
                      <div class="cursor-pointer" @click="goContractDetail(row)">
                        {{ row.projectName }}
                      </div>
                    </template>
                    <template slot="projectPlacementId" slot-scope="scope">
                        <div v-if="scope.row.projectPlacementId>-1" class="cursor-pointer" @click="toDetail(scope.row.projectPlacementId)">
                            查看投放记录
                        </div>
                        <div v-else>
                          待投放
                        </div>
                    </template>                  
                  </avue-crud>
                </template>
              </InfoContainer>
            </template>
          </el-tab-pane>

          <!-- 流程图（启动流程后显示） -->
          <el-tab-pane label="流程跟踪" name="fourth" v-if="isStartedProcess">
            <template v-if="activeName == 'fourth'">
              <el-card shadow="never" style="margin-top: 5px;">
                <wf-design ref="bpmn" style="height: 500px;" :options="bpmnOption"></wf-design>
              </el-card>
            </template>
          </el-tab-pane>

          <!-- 原始附件 -->
          <el-tab-pane
            class="activelabel"
            label="附件信息"
            name="second"
            v-if="basicInfoData.auditStatus != 0 && basicInfoData.flowableId == ''"
          >
            <Accessory
              idname="项目管理"
              :upload="basicInfoData.auditStatus == 0 && permission.project_add"
              :projectid="id"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <BottomLine
        v-if="basicInfoData.auditStatus == 0 || (basicInfoData.auditStatus != 0 && basicInfoData.flowableId != '')"
        ref="bottomLine"
        :auditState="basicInfoData.auditStatus"
        :processDetail="processDetail"
        :isStartedProcess="isStartedProcess"
        :goEdit="!isStartedProcess||(workFlowState.isFirstFlowPermission&&isStartedProcess)"
        @goEdit="goEdit"
        @buildNewOne="buildNewOne"
        @startProcess="saveProject(true)"
        @saveTask="saveTask"
        @saveProject="saveProject"
        @flowNext="flowNext"
        @openPrintForm="goPrint"
        @refreshData="refreshData"
    />
  </basic-container>
</template>

<script>
import InfoContainer from "@/components/infoContainer/infoContainer"
import CommonDetail from "@/components/commonDetail/commonDetail"

// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessory"
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentStep from "@/components/workflowComponents/commentStep/commentStep"
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine"
import workFlow from "@/mixins/workFlow";

// import * as dictionaries from "@/api/zd/dictionaries";
import * as api from "@/api/zd/project";
// import * as util from "@/util/util";
import { mapGetters } from "vuex";

export default {
  name: "projectDetail",
  mixins: [workFlow],
  data() {
    return {
      id: '',
      processKey: 'process_zd_project_manage',
      detailFormUrl: '/zd/project/detail',
      basicInfoData: {},
      activeName: "first",
      projectConfig: {
        infoTitle: '项目信息',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      contractConfig: {
        infoTitle: '合同列表',
        infoContent: [{
          title: '',
          prop: 'contractList'
        }]
      },      
      detailFormConfig: [
        {
          label: '项目名称',
          prop: 'name',
          span: 12,
        },{
          label: '项目编号',
          prop: 'number',
          span: 12,
        },{
          label: '客户名称',
          prop: 'custName',
          span: 12,
        },{
          label: '客户类型',
          prop: 'custTypeText',
          span: 12,
        },{
          label: '客户经理',
          prop: 'managerName',
          span: 12,
        },{
          label: '申请银行',
          prop: 'bankName',
          span: 12,
        },{
          label: '贷款到期金额',
          prop: 'expireQuota',
          span: 12,
          unit: '元',
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          }
        },{
          label: '申请转贷金额',
          prop: 'quota',
          span: 12,
          unit: '元',
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          }
        },{
          label: '预计资金出款时间',
          prop: 'expectPayDate',
          span: 12
        },{
          label: '预计使用天数',
          prop: 'expectUseDay',
          span: 12,
          formatter: (label, value) => {
            return value > -1 ? value +'天': ""
          },
        },{
          label: '使用费率',
          prop: 'loanRate',
          span: 12,
          formatter: (label, value) => {
            return value > -1 ? value * 100 + "%": "-"
          }
        },{
          label: '开户行',
          prop: 'payOpeningBank',
          span: 12,
        },{
          label: '合作银行户名',
          prop: 'payAccountName',
          span: 12,
        },{
          label: '合作银行账号',
          prop: 'payBankAccount',
          span: 12,
        },{
          label: '是否需要总经理审批',
          prop: 'managerAudit',
          span: 12,
          formatter: (label, value) => {
            return value == 0 ? "否": value == 1 ?"是":"-"
          }          
        },{
          label: '是否国企',
          prop: 'isSoe',
          span: 12,
          formatter: (label, value) => {
            return value == 0 ? "否": value == 1 ?"是":"-"
          }    
        },{
          label: '备注',
          span: '24',
          prop: 'remark'
        }
      ],
      contractListData: [],
      contractOption: {
          menu: false,
          align: "center",
          card: true,
          columnBtn: false,
          searchBtn: true,
          refreshBtn:false,
          tip: false,
          simplePage: true,
          searchMenuSpan: 6,
          tree: true,
          editBtn: false,
          addBtn: false,
          delBtn: false,
          labelWidth: 100,
          searchShow: false,
          column: [
            {
              label: "合同名称",
              prop: "projectName",
              width:350,
              slot: true,
              overHidden: true
            },{
              label: "合同金额",
              prop: "amount",
              width:120,
              formatter: (row, value, label, column) => {
                return `${this.getMoney(value)}元`
              }
            },{
              label: "项目投放",
              prop: "projectPlacementId",
              span: 24,
              display: true,
              slot: true,
            },{
              label: "回款状态",
              prop: "loanStatus",
              dicUrl:"/api/blade-system/dict-biz/dictionary?code=loan_status",
              props: {
                label: "dictValue",
                value: "dictKey"
              },
              dataType: "number",
              formatter: (row, value, label, column) => {
                if (value == -1) {
                  return "-";
                } else {
                  return label;
                }
              },
            },
          ]
      },      
    };
  },
  components: {
    InfoContainer,
    CommonDetail,
    Accessory,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock
  },
  watch: {
      '$route.params.id': {
          handler(newId, oldId) {
              this.id = newId
              this.onLoad()
          },
          deep: true
      }
  },
  created() {
    this.id = this.$route.params.id;
    this.onLoad();
  },
  computed: {
    ...mapGetters(["permission","workFlowState"]),
  },
  methods: {
    refreshData() {
      this.onLoad()
    },
    goContractDetail(row) {
      this.$router.push({ path: `/zd/contractmanage/contractDetail/${row.contractId}`});
    },
    toDetail(id){
      this.$router.push({ path: `/zd/placement/detail/${id}`,query:{status:'2'}});
    },    
    queryContractList() {
      api.getContractDetail({id:this.id})
        .then((res) => {
          let data = res.data.data;
          this.page.total = data.length;
          this.contractListData = data;
        })
        .catch((res) => {
          
        });
    },

    goBatch(flowableId) {
      this.$router.push({path: `/zd/project/flows/${flowableId}`})
    },
    //获取详情
    onLoad() {
      api.info({ id: this.id }).then(async(res) => {
        if(res.data.code == 200) {
          this.basicInfoData = res.data.data;
          // this.getBasicConfigData()

          // 查询流程数据
          this.$store.commit('SET_WORKFLOW_STATE', {state: this.basicInfoData.auditStatus})
          if(res.data.data && res.data.data.flowableId) {
              this.isStartedProcess = true
              // 集成在workFlow.js中
              await this.queryFlowData(res.data.data.flowableId)
          } else {
              this.isStartedProcess = false
              this.flowData = []
              this.commentList = []
              // 未启动流程 查询第一个节点的文件上传权限
              this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
              this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
              // 设置流程表单路径
              this.queryProcessFormDetail(this.processDefinedId)
          }
        }
      })
      .catch((res) => {
        
      });
    },

    async getBasicConfigData() {
        this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
        // 获取当前流程文件上传列表权限 permissionList
        this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId)
    },

    fileChange(fileList) {
        let self = this
        if(fileList.length > 0) {
            this.attchmentList = []
            fileList.map(item => {
                self.attchmentList.push({
                    name: item.name,
                    url: item.response.data.link
                })
            })
        }
    },

    // 保存尽调数据
    async saveTask() {
        await this.workFlowSaveTask()
        // 刷新数据
        this.saveTask = {
            comment: '',
            attachment: []
        }
        this.onLoad()
        this.$forceUpdate()
    },

    // 流程流转
    async flowNext() {
        let processInsId = this.processDetail.process.processInstanceId
        let taskId = this.processDetail.process.taskId
        let valid = false
        // 流程表单数据
        if(this.$refs.auditInfo.avueFormConfig.column && this.$refs.auditInfo.avueFormConfig.column.length > 0){
            valid = this.$refs.auditInfo.validData()
        }else {
            valid = true
        }
        if(valid){
            let customData = this.$refs.auditInfo.commentDetail
            let formData = this.$refs.auditInfo.$data.formData

            let variables = this.dealAuditForm(formData, customData)

            let res = await this.taskFlowNext(
                taskId,
                processInsId,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables
            )
            // 刷新数据
            this.onLoad()
            this.$forceUpdate()
        }
    },

    //编辑
    goEdit(id) {
      if(this.basicInfoData.managerUser == this.userInfo.user_id || this.basicInfoData.assistUser == this.userInfo.user_id) {
        this.$router.push({ path: `/zd/project/approval/${this.id}` });
      }else {
          this.$message.error('您暂无权限对本条数据进行编辑')
      }
    },

    async saveProject() {
      let params = {
        custId: this.basicInfoData.custId>-1?this.basicInfoData.custId:undefined,
        custType: this.basicInfoData.custType || "",
        bankId: this.basicInfoData.bankId>-1?this.basicInfoData.bankId:undefined,
        managerUser: this.basicInfoData.managerUser || "",
        expireQuota: this.basicInfoData.expireQuota || "",
        name: this.basicInfoData.name || "",
        quota: this.basicInfoData.quota || "",
        expectPayDate: this.basicInfoData.expectPayDate || "",
        expectUseDay: this.basicInfoData.expectUseDay || "",
        loanRate: this.basicInfoData.loanRate || "",
        payOpeningBank: this.basicInfoData.payOpeningBank || "",
        payAccountName: this.basicInfoData.payAccountName || "",
        payBankAccount: this.basicInfoData.payBankAccount || "",
        id: this.id > -1 ? this.id : undefined,
        managerAudit: this.basicInfoData.managerAudit || 0,
        isSoe: this.basicInfoData.isSoe || "",
        remark: this.basicInfoData.remark
      }

      let redirectInfo ={
          url: this.detailFormUrl,
          id: this.id
      }
      let processInsId = ''
      if(this.basicInfoData.managerUser == this.userInfo.user_id || this.basicInfoData.assistUser == this.userInfo.user_id) {

          // let processNameRes = await getPocessName(params) 
          let processParams = {
              detailFormUrl:  JSON.stringify(redirectInfo),
              processId: this.processDefinedId,
              comment: this.$refs.commentBlock.$data.opinionContent,
              attachmentList: this.attchmentList,
              processInstanceName: `${this.basicInfoData.projectName}合同结清流程`,
              riskExposure: Number(this.basicInfoData.factoringCredit),
              managerAudit: this.basicInfoData.managerAudit
          }
          processInsId = await this.startWorkFlowProcess(processParams)
          // params.flowableId = processInsId
      }else {
          this.$message.error('您暂无权限提交本条数据流程')
          return false
      }

      let redirectInfos ={
          url: '/zd/project/flows',
          id: processInsId
      }      
      
      let batchParams = {
        detailFormUrl: JSON.stringify(redirectInfos),
        flowableId: processInsId,
        batchIds: [this.id],
        batchNames: [this.basicInfoData.projectName],
        fileMenuName: this.uploadPermissionNameTwo,
        fileMenuUrlName: this.uploadPermissionNameOne,
        remark: ''
      }

      let res = await api.submit(params)
      if(res.data.code == 200){
        // 调取批量审批接口
        let batchRes = await api.submitBatch(batchParams) 
        if(batchRes.data.code == 200 ) {
          this.onLoad()
          this.$message({
              message: '流程发起成功',
              type: 'success'
          })
        }

      }
    },
    updatastate(type) {
      let that = this;
      //examine ture  审批  false 审核
      api
        .submitWorkflowCheck({ id: this.data.id })
        .then((res) => {
          
          if (type) {
            this.$confirm("是否确定提交审批?", "操作确认", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                api
                  .submitWorkflow({ id: this.data.id })
                  .then((res) => {
                    this.$alert(
                      "数据已同步至OA系统，请您前往OA工作流中查看",
                      "信息提示",
                      {
                        confirmButtonText: "确定",
                        callback: (action) => {
                          this.$message({
                            type: "info",
                            message: "请您前往OA工作流中查看",
                          });
                        },
                      }
                    );
                    this.onLoad(this.$route.params.id);
                  })
                  .catch((res) => {
                    
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          } else {
            this.$confirm("是否确定提交审核?", "操作确认", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.butshengheloading = true;
                api
                  .submitaudit({ id: this.data.id })
                  .then((res) => {
                    
                    this.$message({
                      type: "success",
                      message: res.data.msg,
                    });
                    this.onLoad(this.$route.params.id);
                  })
                  .catch((res) => {
                    
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          }
        })
        .catch((res) => {
          const confirmText = ["必填内容填写不完全", "请检查数据内容是否完整"];
          const newDatas = [];
          const h = that.$createElement;
          for (const i in confirmText) {
            newDatas.push(h("p", null, confirmText[i]));
          }
          that
            .$confirm("警告提示", {
              title: "提示",
              message: h("div", null, newDatas),
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {})
            .catch(() => {
              that.$message({
                type: "info",
                message: "已取消",
              });
            });
        });
    },

    // 审核权限  进行通过和退回保存
    onSubmitAudit() {
      this.$refs.auditForm.validate((vaild) => {
        
        if (vaild) {
          let data = {
            id: this.id,
            ...this.auditForm,
          };
          api.audit(data).then(
            (res) => {
              this.auditVisible = false;
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.onLoad();
              // this.$router.go(-1);
            },
            (error) => {
              
            }
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanageDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    margin-bottom: 25px;
    position: relative;
  }
  .history {
    position: absolute;
    top: 50%;
    right: -15px;
    .history_content {
      width: 100px;
      height: 35px;
      background: #409eff;
      line-height: 35px;
      color: #fff;
      text-align: right;
      padding-right: 15px;
      border-radius: 5px 0 0 5px;
    }
  }
  .banktail_ {
    width: 1000px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;

    .bankname {
      font-size: 18px;
      color: #333;
      font-weight: 700;
      display: flex;
      align-items: center;
      .audit_tip {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-weight: 400;
        font-size: 10px;
        margin-right: 10px;
        padding: 5px 10px;
        // width: 90px;
        // height: 30px;
        background-color: rgba(254, 192, 61, 1);
        border: none;
        border-radius: 35px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
      .audit_success {
        // width: 150px;
        background-color: rgba(25, 190, 107, 1);
      }
    }
  }
  .bankcontent {
    position: relative;
    margin: 20px 0;
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 15px;
      display: flex;

      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        width: 100%;
        display: flex;
        flex-direction: row;
        text-align: right;
        .list_top {
          flex: 1;
        }
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.relending-detail-container{
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  // /deep/.info-container-temp .box-card .detail-one {
  //   padding: 0 !important;
  // }
  .cursor-pointer {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409eff;
  }
  .cursor-pointer:hover {
    color: #409eff;
    cursor: pointer;
  }  
  .inner-con{
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name:hover{
      color: #409EFF;
      cursor: pointer;
    }
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
      .title-number{
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #409EFF;
        cursor: pointer;
      }
    }
    .project-status{
      .status-title{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }    
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #F56C6C;
  }
  .color_4::before {
    background: #F56C6C;
  }  
}

.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 12px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
.box_cards {
  height: 450px;
  overflow-y: auto;
}

.form_wrapper {
  height: 100%;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);

    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }

  .form_content_form {
    padding: 20px 50px;
    border: 1px solid #e2e2e2;
  }
}
/deep/.el-tabs__header {
  margin: 0px;
}
/deep/ .avue-crud {
  width: 100%;
}
.informationxm {
  margin-top: 20px;
}
/deep/.avue-crud__menu {
  display: none;
}
/deep/.avue-crud {
  width: 100%;
}
/deep/.avue-crud .el-table th {
  background-color: #ffffff;
  line-height: 50px;
  padding: 0;
}
/deep/.el-table .cell,
.el-table th > .cell {
  padding-left: 20px;
}
/deep/.el-table__empty-block {
  border-right: none;
}
/deep/ .avue-crud__pagination {
  padding: 0;
}
/deep/.el-tabs__item {
  font-size: 18px ;
  font-weight: bolder ;
  margin-bottom: 10px ;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
</style>

